import React, { useState } from "react";
import { Play, Phone, Key } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LostAllYourKeys() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const shared_data = {
    phone: "07700 123456",
    business_name: "AngliaKeys"
  };
  return <section id="lost-all-your-keys" ref={ref} className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/60 z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573441/img/stressed_driver_soft_focus.png" alt="Driver looking stressed by their car" className="w-full h-full object-cover blur-[2px] scale-105" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 text-center">
        <div className={`transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="inline-flex items-center justify-center p-3 mb-6 rounded-full bg-primary/20 border border-primary/50 backdrop-blur-md">
            <Key className="w-8 h-8 text-primary animate-pulse" />
          </div>

          {}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight drop-shadow-lg">
            No Key? <span className="text-primary">No Problem.</span>
          </h1>

          {}
          <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-2xl mx-auto font-light leading-relaxed">
            Don't panic. We specialise in total loss situations. 
            We come to you and get you back on the road—fast.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Dialog open={isVideoOpen} onOpenChange={setIsVideoOpen}>
              <DialogTrigger asChild>
                <Button size="lg" variant="secondary" className="group text-lg h-14 px-8 rounded-full border-2 border-white/10 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white transition-all duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(255,255,255,0.3)]">
                  <Play className="w-5 h-5 mr-2 fill-current group-hover:text-primary transition-colors" />
                  Watch how we do it
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-3xl bg-card/95 backdrop-blur-xl border-white/10 text-foreground">
                <DialogHeader>
                  <DialogTitle className="text-2xl font-bold flex items-center gap-2">
                    <Key className="w-5 h-5 text-primary" />
                    Mobile Key Cutting Process
                  </DialogTitle>
                  <DialogDescription>
                    See how our technicians cut and program new keys right at your location.
                  </DialogDescription>
                </DialogHeader>
                <div className="aspect-video w-full bg-black/90 rounded-lg overflow-hidden flex items-center justify-center border border-white/10 shadow-inner relative group">
                  {}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Play className="w-16 h-16 text-white/20 group-hover:text-primary/80 transition-all duration-500 scale-100 group-hover:scale-110" />
                  </div>
                  <p className="text-white/50 font-mono text-sm z-10">
                    [Video Placeholder: Mobile Technician Demonstration]
                  </p>
                </div>
              </DialogContent>
            </Dialog>

            <Link to="/contact" className="hidden sm:inline-flex">
               <Button size="lg" className="text-lg h-14 px-8 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_20px_rgba(255,180,0,0.4)] hover:shadow-[0_0_30px_rgba(255,180,0,0.6)] transition-all duration-300">
                 Get Help Now
               </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="fixed bottom-6 right-6 z-50 sm:hidden">
        <Link to={`tel:${shared_data.phone.replace(/\s/g, "")}`}>
          <Button size="icon" className="w-16 h-16 rounded-full bg-primary text-primary-foreground shadow-[0_4px_20px_rgba(0,0,0,0.5)] hover:bg-primary/90 animate-bounce hover:animate-none border-4 border-background/20" aria-label="Call Now">
            <Phone className="w-8 h-8" />
          </Button>
        </Link>
      </div>
    </section>;
}